import { useTranslation } from "react-i18next";

type unit = ["C" | "P" | "%"];

type displayValueProps = {
  value: number | string | boolean;
  unit?: unit;
};

export const DisplayValue = ({ value, unit }: displayValueProps) => {
  const { t } = useTranslation();

  return (
    <div className="text-sm">
      {typeof value === "boolean" && (
        <div>{value ? t("common-yes") : t("common-no")}</div>
      )}
      {typeof value === "string" && <div> {value} </div>}
      {typeof value === "number" && (
        <div>
          {value.toString()} {unit}
        </div>
      )}
    </div>
  );
};
